import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { SideBarItemContainer } from '../../styles'; 
import { scrollDown } from 'utils/scrollDown';

const CustomGroupRenderer = ({ group }) => {

  const location = useLocation();
  const roomRef = useRef();

  // Scroll to room on first render
  useEffect(() => {
    if (roomRef.current) scrollDown(roomRef.current?.offsetTop, 1000);
  }, []);

  const isOutOfOrder = group.status === 'OUT_OF_ORDER';

  return (
    <SideBarItemContainer
      key={group.id}
      ref={group.id === location.state?.roomNumber ? roomRef : null}
      warning={isOutOfOrder}
    >
      {group.id}
      {isOutOfOrder && <div className="warningCover"></div>}
    </SideBarItemContainer>
  );
};

export default CustomGroupRenderer;